/**
 * officeChat(Electron 기반 officenext-desktop) webview 환경 판별 유틸.
 *
 * 실측 userAgent 예:
 * Mozilla/5.0 (...) officenext-desktop/1.9.105 Chrome/146.0.7680.188 Electron/41.2.1
 * Safari/537.36 OfficeNEXT/1.9.105 OfficeChat/1.9.105
 */
const OFFICE_CHAT_UA_TOKENS = ['OfficeChat', 'OfficeNEXT', 'officenext-desktop']

/**
 * 개발/로컬 환경 전용 userAgent 오버라이드 키.
 * officeChat webview 동작은 운영 서버에서만 실기기 확인이 가능하므로,
 * 로컬 검증/E2E를 위해 localStorage에 fake UA를 넣어 감지 루틴을 시뮬레이션한다.
 * 예: localStorage.setItem('fake-userAgent', '... OfficeChat/1.9.105') 후 새로고침.
 * production 빌드에서는 분기 코드가 define 상수로 제거되어 동작하지 않는다.
 */
export const FAKE_UA_STORAGE_KEY = 'fake-userAgent'

function resolveUserAgent(): string {
  if (__ENV_DEVELOPMENT__ || __ENV_LOCAL__) {
    try {
      const fakeUserAgent = window.localStorage.getItem(FAKE_UA_STORAGE_KEY)
      if (fakeUserAgent) return fakeUserAgent
    } catch {
      // storage 접근 불가 환경(프라이빗 모드 등)에서는 실제 UA로 진행
    }
  }
  return window.navigator.userAgent
}

/**
 * officeChat(Electron) webview에서 열렸는지 판별한다.
 * 'Electron' 단독 토큰은 타 Electron 앱 오탐 여지가 있어 판별에 사용하지 않는다.
 */
export function isOfficeChatWebview(userAgent: string = resolveUserAgent()): boolean {
  return OFFICE_CHAT_UA_TOKENS.some((token) => userAgent.indexOf(token) > -1)
}

/**
 * 로그인 실패 시 이동할 경로를 반환한다.
 * OfficeChat webview에서는 로그인 화면이 의미가 없으므로 재실행 안내 화면으로 보낸다.
 */
export function getLoginFailureRedirect(): string {
  return isOfficeChatWebview() ? '/auth/restart-required' : '/auth/login'
}
